import React from "react";
import fb from "../../lib/firebase";
import {EntityList} from "../../components/EntityListNG";
import FormEvento from "../Eventos/FormEventoHOC";
import {LojaObject} from "../../models/Loja";
import {EventoObject} from "../../models/Evento";
import {PathDescription} from "../../models/Core";
import {cardTitle, cardContent, cardSubtitle} from "../Eventos/EventoCard";
import {filtrarColecao} from "../../lib/utils";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";


interface Props {
  instance: LojaObject;
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  loading: boolean;
  colecao: any[];
  colecaoFiltrada: any[];
}

class AbaEventos extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props:Props) {
    super(props);

    this.state = {
      loading: false,
      colecao: [],
      colecaoFiltrada: [],
    };

    this.cancelListener = () => {};
  }

  componentDidMount() {
    this.installListener();
  }

  componentWillUnmount() {
    this.cancelListener();
  }

  installListener = () => {
    this.setState({loading: true});
    const query = fb.db.collection('eventos')
      .where('owner', '==', this.props.app.user.uid)
      .where('principal.path', '==', fb.db.collection('lojas').doc(this.props.instance.id))
      .orderBy("data", "desc")

    this.cancelListener = query.onSnapshot(snap => {
      const colecao = fb.col(snap);
      this.setState({colecao, loading: false});
      this.filtrarColecao();
    });
  };

  filtrarColecao = (criterio:string='') => {
    this.setState({
      colecaoFiltrada: filtrarColecao(this.state.colecao, criterio, 'descricao')
    });
  }

  onClickInstance = (instance: EventoObject) => {
    this.props.dispatch(actions.jump(`/lojas/${this.props.instance.id}/eventos`));
    this.props.history.push(`/eventos/${instance.id}/home`);
  };

  render() {
    return (
      <EntityList
        entityLabel="evento"
        colecao={this.state.colecaoFiltrada}
        loading={this.state.loading}
        filtrarColecao={this.filtrarColecao}
        addEnabled={true}
        onClickInstance={this.onClickInstance}
        cardSubTitle={cardSubtitle}
        cardTitle={cardTitle}
        cardContent={cardContent}
        ModelForm={FormEvento}
        modelFormProps={{
          principal: {
            collection: 'lojas',
            id: this.props.instance.id,
            label: `Loja: ${this.props.instance.nome}`,
          } as PathDescription
        }}
      />
    );
  }
}

export default connect(({app}: RootState) => ({app}))(AbaEventos);